/* eslint-disable */
// THIS FILE IS GENERATED. DO NOT EDIT. Edits should be made in 'media.scss' instead.
import { css } from 'lit';
export default css `:host([slot=media]){border-radius:0;margin-top:0;width:100%}@media (min-width:768px){:host([slot=media]){max-height:var(--hero-max-height)}}:host([slot=media]) img{border-radius:0;display:block;height:100%;-o-object-fit:cover;object-fit:cover;width:100%}`;
//# sourceMappingURL=media.scss.js.map